// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { ScheduledOp_abstract } from './../abstract/SagaBase/ScheduledOp_abstract';
export class ScheduledOp extends ScheduledOp_abstract {}
